import { render } from "./NoOffers.vue?vue&type=template&id=1e1e6d8b"
import script from "./NoOffers.vue?vue&type=script&lang=js"
export * from "./NoOffers.vue?vue&type=script&lang=js"
script.render = render

export default script